import React, { useState, useEffect } from "react";
// import { Logo, Eye } from '../images/Svgs'
// import { emailValidation, passValidation } from "../utils/validators";
import { useNavigate } from "react-router";
import { LoginRequest } from "../API/Auth";
import { toast } from "react-toastify";
import { EyeOpenSvg, EyeCloseSvg } from "../images/Svgs";
import Logo from "../images/logo.png";

const Login = () => {
  let navigate = useNavigate();
  const [data, setData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [passwordType, setPasswordType] = useState("password");
  const [passwordShow, setPasswordShow] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Update data state
    setData({ ...data, [name]: value });
  
    // Validation for email field
    if (name === "email") {
      if (!value) {
        setErrors({ ...errors, email: "Email is required" });
      } else if (!emailRegex.test(value)) {
        setErrors({ ...errors, email: "Invalid email format" });
      } else {
        setErrors({ ...errors, email: "" });
      }
    }
  
    // Validation for password field
    if (name === "password") {
      if (!value) {
        setErrors({ ...errors, password: "Password is required" });
      } else {
        setErrors({ ...errors, password: "" });
      }
    }
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.email && !data.password) {
      setErrors({
        ...errors,
        email: "Email is required",
        password: "Password is required",
      });
      return false;
    } else if (!data.email) {
      setErrors({ ...errors, email: "Email is required" });
      return false;
    }else if (!emailRegex.test(data.email)) {
      setErrors({ ...errors, email: "Invalid email format" });
      return false;
    }
     else if (!data.password) {
      setErrors({ ...errors, password: "Password is required" });
      return false;
    } else {
      setErrors({ ...errors, password: "" });
      let payload = { email: data.email, password: data.password };
      try {
        const response = await LoginRequest(payload);

        if (response?.status) {
          var now = new Date().getTime();
          toast.success(response.message || "Success!");
          localStorage.setItem("ct_token", response?.data?.token); // Save the token in localStorage
          localStorage.setItem("userDetail", JSON.stringify(response?.data)); 
          localStorage.setItem('setupTime', now);
          navigate("/dashboard"); // Navigate to the dashboard
        } else {
          console.log("Login failed:", response.message); // Handle failed login response
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error during login request:", error); // Handle any other errors
      }
    }
  };

  const handleType = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  return (
    <div class="login-sec">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="form-inner">
              <img src={Logo} title="Celebration Talent Competition" alt=""/>
              <h3>Welcome Back</h3>
              <div class="input-sec">
                <label for="exampleFormControlInput1" class="form-label">
                  Email
                </label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Email Address"
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <p className="login_error_message">{errors.email}</p>
                )}
              </div>
              <div class="input-sec password_icon">
                <label for="inputPassword5" class="form-label">
                  Password
                </label>
                <input
                  type={passwordShow ? "text" : "password"}
                  id="inputPassword5"
                  placeholder="Password"
                  class="form-control"
                  aria-describedby="passwordHelpBlock"
                  name="password"
                  value={data.password}
                  onChange={handleChange}
                />

                <div
                  className="i_icon"
                  onClick={() => {
                    setPasswordShow(!passwordShow);
                  }}
                >
                  {passwordShow ? <EyeOpenSvg /> : <EyeCloseSvg />}
                </div>
                {errors.password && (
                  <p className="login_error_message">{errors.password}</p>
                )}
              </div>
              {/* <a href="#" class="forgot-pass">forgot Password?</a> */}
              <div class="login-action">
                <a href="#" onClick={(e) => handleSubmit(e)}>
                  CONTINUE
                </a>
              </div>
              {/* <p>Doesn’t have an account?<a href="#"> Sign up now</a></p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
